import WithRender from "../../templates/layouts/layoutAdminPreferredSelection.html";

export default WithRender({
  computed: {}
});
